import { Injectable } from '@angular/core';

import {
	DeleteAvatarResponse,
	SetAvatarResponse,
	SetAvatarUrlResponse,
} from '@reach/interfaces/avatar/avatar.responses';

import { BaseApiService } from '~app-client/api/_internal';
import { ReachNodeId } from '~app-client/core/types';

@Injectable({ providedIn: 'root' })
export class ThumbnailsApiService extends BaseApiService {
	protected commonPath = ['node-pictures'];

	public async addThumbnail(nodeId: ReachNodeId, file: File): Promise<SetAvatarResponse> {
		const formData = new FormData();
		formData.append('image', file);

		return await this.http.post<SetAvatarResponse>(this.url(nodeId), formData);
	}

	public async addUrl(nodeId: ReachNodeId, url: string): Promise<SetAvatarUrlResponse> {
		const body = { url };
		return await this.http.post<SetAvatarUrlResponse>(this.url(nodeId, 'url'), body);
	}

	public async deleteThumbnail(nodeId: ReachNodeId): Promise<DeleteAvatarResponse> {
		return await this.http.delete<DeleteAvatarResponse>(this.url(nodeId));
	}
}
